import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import About from './pages/About'
import Thoughts from './pages/thoughts'
import MorphingEffect from './pages/thoughts/morphing-effect'
import AIArchitecture from './pages/thoughts/ai-architecture'
import VisualDesign from './pages/thoughts/visual-design'
import CoreConcepts from './pages/thoughts/core-concepts'
import CreativeFreedom from './pages/thoughts/creative-freedom'
import MobileMocks from './pages/thoughts/mobile-mocks'
import MindSync from './pages/thoughts/mind-sync'
import EvolutionOfIdea from './pages/thoughts/evolution-of-idea'
import Ruler from './pages/thoughts/ruler'
import Chibatore from './pages/thoughts/chibatore'
import ThoughtChibatore2 from './pages/thoughts/chibatore-2'
import MySetup from './pages/thoughts/my-setup'
import Cards from './pages/thoughts/cards'
import ThoughtMicrocosm from './pages/thoughts/microcosm'
import './styles/globals.css'

// Create a wrapper component for the Navigate component
const RedirectToHome = () => {
  const location = useLocation()
  return <Navigate to={`/${location.search}`} replace />
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/about" element={<About />} />
        <Route path="/thoughts" element={<Thoughts />} />
        <Route path="/thoughts/microcosm" element={<ThoughtMicrocosm />} />
        <Route path="/thoughts/morphing-effect" element={<MorphingEffect />} />
        <Route path="/thoughts/ai-architecture" element={<AIArchitecture />} />
        <Route path="/thoughts/visual-design" element={<VisualDesign />} />
        <Route path="/thoughts/core-concepts" element={<CoreConcepts />} />
        <Route path="/thoughts/creative-freedom" element={<CreativeFreedom />} />
        <Route path="/thoughts/mobile-mocks" element={<MobileMocks />} />
        <Route path="/thoughts/mind-sync" element={<MindSync />} />
        <Route path="/thoughts/evolution-of-idea" element={<EvolutionOfIdea />} />
        <Route path="/thoughts/ruler" element={<Ruler />} />
        <Route path="/thoughts/chibatore" element={<Chibatore />} />
        <Route path="/thoughts/chibatore-2" element={<ThoughtChibatore2 />} />
        <Route path="/thoughts/my-setup" element={<MySetup />} />
        <Route path="/thoughts/cards" element={<Cards />} />
        <Route path="/" element={<Navigate to="/about" replace />} />
        <Route path="*" element={<RedirectToHome />} />
      </Routes>
    </BrowserRouter>
  )
} 